import React from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';

interface DuplicateNotificationProps {
  existingPaper: {
    id: string;
    title: string;
    external_url: string;
  };
  onViewPaper: (paperId: string) => void;
  onDismiss?: () => void;
}

export const DuplicateNotification: React.FC<DuplicateNotificationProps> = ({
  existingPaper,
  onViewPaper,
  onDismiss
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Alert className="border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950/20">
        <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
        <AlertDescription className="space-y-3">
          <div>
            <p className="font-medium text-green-800 dark:text-green-200">
              Great News! Paper Found
            </p>
            <p className="text-sm text-green-700 dark:text-green-300 mt-1">
              This research is already available on our platform and ready for you to explore:
            </p>
            <p className="text-sm font-medium text-green-800 dark:text-green-200 mt-2 bg-green-100 dark:bg-green-900/30 p-2 rounded">
              "{existingPaper.title}"
            </p>
          </div>
          
          <div className="flex flex-wrap gap-2">
            <Button
              onClick={() => onViewPaper(existingPaper.id)}
              className="bg-green-600 hover:bg-green-700 text-white border-0"
              size="sm"
            >
              <ExternalLink className="h-3 w-3 mr-1" />
              View & Discuss Paper
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </motion.div>
  );
};